import { useState } from 'react';

export const useRuleSelection = (rules = []) => {
  const [selectedRuleIds, setSelectedRuleIds] = useState([]);

  const toggleRule = (ruleId) => {
    setSelectedRuleIds(prev => {
      if (prev.includes(ruleId)) {
        return prev.filter(id => id !== ruleId);
      } else {
        return [...prev, ruleId];
      }
    });
  };

  const selectAll = () => {
    if (selectedRuleIds.length === rules.length) {
      setSelectedRuleIds([]);
    } else {
      setSelectedRuleIds(rules.map(rule => rule.id));
    }
  };

  const clearSelection = () => {
    setSelectedRuleIds([]);
  };

  const isAllSelected = selectedRuleIds.length === rules.length && rules.length > 0;

  return {
    selectedRuleIds,
    toggleRule,
    selectAll,
    clearSelection,
    isAllSelected,
  };
};
